exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog[data-v-204f7a3e] {\n    min-width: 700px;\n}\n.button-add-remove-input[data-v-204f7a3e] {\n    width: 45px; \n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.btn-clear-orgaos-selected-licitacao[data-v-204f7a3e] {\n    width: 45px; \n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n}\n", ""]);

// exports
